import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { environment } from 'environments/environment';
import { Observable, from, switchMap, take } from 'rxjs';
/**
 * Appends `Authorization` header if user is logged in
 *
 * @export
 * @class HeaderInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class BearerAuthInterceptor implements HttpInterceptor {
  constructor(private _afAuth: Auth) {}
  static timezoneoffset = ((new Date().getTimezoneOffset() / 60) * -1).toString();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.baseApiUrl) && !req.url.includes('enumerators')) {
      return from(this._afAuth.currentUser.getIdToken()).pipe(
        take(1),
        switchMap((token: any) => {
          if (token) {
            req = req.clone({
              setHeaders: { Authorization: `Bearer ${token}` }
            });
          }
          return next.handle(req);
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
